<template>
  <div class="mainImg">
    <img src="../assets/TB1EBxZrwoQMeJjy0FoXXcShVXa-1127-508.png"  >
    <div class="point-area p1" >
    <p class="point-name" style="position: absolute; top: 28px; left: 60px;">{{$t('city[0]')}}</p>
    <a  class="point point-dot" >
    </a><div class="point point-10">
  </div><div class="point point-40">
  </div><div class="point point-shadow point-80">

  </div></div>

    <div class="point-area p2" >
      <p class="point-name" style="position: absolute; top: 28px; left: 60px;">{{$t('city[1]')}}</p>
      <a  class="point point-dot" >
      </a><div class="point point-10">
    </div><div class="point point-40">
    </div><div class="point point-shadow point-80" >

    </div></div>

    <div class="point-area p3" >
      <p class="point-name" style="position: absolute; top: 28px; left: 60px;">{{$t('city[2]')}}</p>
      <a  class="point point-dot" >
      </a><div class="point point-10">
    </div><div class="point point-40">
    </div><div class="point point-shadow point-80">

    </div></div>

    <div class="point-area p4" >
      <p class="point-name" style="position: absolute; top: 28px; left: 60px;">{{$t('city[3]')}}</p>
      <a  class="point point-dot" >
      </a><div class="point point-10">
    </div><div class="point point-40">
    </div><div class="point point-shadow point-80">

    </div></div>

    <div class="point-area p5">
    <p class="point-name" style="position: absolute; top: 48px; left: 80px;">{{$t('city[4]')}}</p>
    <a class="point point-dot" data-spm-anchor-id="5176.8142029.414699.4"></a>
    <div class="point point-10"></div>
    <div class="point point-40"></div>
    <div class="point point-shadow point-80"></div>
  </div>

    <div class="point-area p6" >
    <p class="point-name" style="position: absolute; top: 30px; left: 50px;">{{$t('city[5]')}}</p>
    <a  class="point point-dot" ></a>
    <div class="point point-10"></div>
    <div class="point point-70"></div>
  </div>

    <div class="point-area p7" >
      <p class="point-name" style="position: absolute; top: 30px; left: 50px;color: red;">{{$t('city[6]')}}</p>
      <a  class="point point-dot" style="background-color: red;" ></a>
      <div class="point point-10"></div>
      <div class="point point-70"></div>
    </div>

    <div class="point-area p8">
      <p class="point-name" style="position: absolute; top: 30px; left: 50px;">{{$t('city[7]')}}</p>
      <a  class="point point-dot" ></a>
      <div class="point point-10"></div>
      <div class="point point-70"></div>
    </div>


    <div class="point-area p9">
      <p class="point-name" style="position: absolute; top: 30px; left: 50px;">{{$t('city[8]')}}</p>
      <a  class="point point-dot" ></a>
      <div class="point point-10"></div>
      <div class="point point-70"></div>
    </div>


    <div class="point-area p10">
    <p class="point-name" style="position: absolute; top: 18px; left: 50px;">{{$t('city[9]')}}</p>
    <a  class="point point-dot"></a>
    <div class="point point-10"></div>
    <div class="point point-70"></div>
  </div>

    <div class="point-area p11" >
      <p class="point-name" style="position: absolute; top: 18px; left: 50px;">
        {{$t('city[10]')}}</p>
      <a  class="point point-dot" ></a>
      <div class="point point-10"></div>
      <div class="point point-70">

      </div></div>

    <div class="point-area p12">
    <p class="point-name" style="position: absolute; top: 55px; left: 85px;">{{$t('city[11]')}}</p>
    <a  class="point point-dot" ></a>
    <div class="point point-10"></div>
    <div class="point point-40"></div>
    <div class="point point-shadow point-80">

    </div></div>

    <div class="point-area p13" >
      <p class="point-name" style="position: absolute; top: 30px; left: 0px;">{{$t('city[14]')}}</p>
      <a  class="point point-dot" ></a>
      <div class="point point-10"></div>
      <div class="point point-70"></div>
    </div>


    <div class="point-area p14">
      <p class="point-name" style="position: absolute; top: 55px; left: 85px;">{{$t('city[12]')}}</p>
      <a  class="point point-dot" ></a>
      <div class="point point-10"></div>
      <div class="point point-40"></div>
      <div class="point point-shadow point-80">

      </div></div>

    <div class="point-area p15">
      <p class="point-name" style="position: absolute; top: 18px; left: 50px;">{{$t('city[13]')}}</p>
      <a  class="point point-dot"></a>
      <div class="point point-10"></div>
      <div class="point point-70"></div>
    </div>

    <div class="point-area p16">
      <p class="point-name" style="position: absolute; top: 18px; left: 0px;">{{$t('city[15]')}}</p>
      <a  class="point point-dot"></a>
      <div class="point point-10"></div>
      <div class="point point-70"></div>
    </div>

    <div class="point-area p17">
      <p class="point-name" style="position: absolute; top: 18px; left: 50px;">{{$t('city[16]')}}</p>
      <a  class="point point-dot"></a>
      <div class="point point-10"></div>
      <div class="point point-70"></div>
    </div>

    <div class="point-area p18">
      <p class="point-name" style="position: absolute; top: 30px; left: -40px;">{{$t('city[17]')}}</p>
      <a  class="point point-dot"></a>
      <div class="point point-10"></div>
      <div class="point point-70"></div>
    </div>

    <div class="point-area p19">
      <p class="point-name" style="position: absolute; top: 18px; left: 0px;">{{$t('city[18]')}}</p>
      <a  class="point point-dot"></a>
      <div class="point point-10"></div>
      <div class="point point-70"></div>
    </div>

    <div class="point-area p20">
      <p class="point-name" style="position: absolute; top: 18px; left: 0px;">{{$t('city[19]')}}</p>
      <a  class="point point-dot"></a>
      <div class="point point-10"></div>
      <div class="point point-70"></div>
    </div>

    <div class="point-area p21">
      <p class="point-name" style="position: absolute; top: 18px; left: 0px;">{{$t('city[20]')}}</p>
      <a  class="point point-dot"></a>
      <div class="point point-10"></div>
      <div class="point point-70"></div>
    </div>

    <div class="point-area p22">
    <p class="point-name" style="position: absolute; top: 18px; left: 0px;">{{$t('city[21]')}}</p>
    <a  class="point point-dot"></a>
    <div class="point point-10"></div>
    <div class="point point-70"></div>
  </div>

    <div class="point-area p23">
      <p class="point-name" style="position: absolute; top: 18px; left: 0px;">{{$t('city[22]')}}</p>
      <a  class="point point-dot"></a>
      <div class="point point-10"></div>
      <div class="point point-70"></div>
    </div>


    <div class="point-area p24">
      <p class="point-name" style="position: absolute; top: 18px; left: 0px;">{{$t('city[23]')}}</p>
      <a  class="point point-dot"></a>
      <div class="point point-10"></div>
      <div class="point point-70"></div>
    </div>

    <div class="point-area p25">
      <p class="point-name" style="position: absolute; top: 18px; left: 0px;">{{$t('city[24]')}}</p>
      <a  class="point point-dot"></a>
      <div class="point point-10"></div>
      <div class="point point-70"></div>
    </div>

    <div class="point-area p26">
      <p class="point-name" style="position: absolute; top: 18px; left: 50px;">{{$t('city[25]')}}</p>
      <a  class="point point-dot"></a>
      <div class="point point-10"></div>
      <div class="point point-70"></div>
    </div>

    <div class="point-area p27">
      <p class="point-name" style="position: absolute; top: 18px; left: 0px;">{{$t('city[26]')}}</p>
      <a  class="point point-dot"></a>
      <div class="point point-10"></div>
      <div class="point point-70"></div>
    </div>

    <div class="point-area p28">
      <p class="point-name" style="position: absolute; top: 18px; left: 0px;">{{$t('city[27]')}}</p>
      <a  class="point point-dot"></a>
      <div class="point point-10"></div>
      <div class="point point-70"></div>
    </div>

    <div class="point-area p29">
      <p class="point-name" style="position: absolute; top: 18px; left: 0px;">{{$t('city[28]')}}</p>
      <a  class="point point-dot"></a>
      <div class="point point-10"></div>
      <div class="point point-70"></div>
    </div>

    <div class="point-area p30">
      <p class="point-name" style="position: absolute; top: 18px; left: 0px;">{{$t('city[29]')}}</p>
      <a  class="point point-dot"></a>
      <div class="point point-10"></div>
      <div class="point point-70"></div>
    </div>

    <div class="point-area p31">
      <p class="point-name" style="position: absolute; top: 18px; left: 0px;">{{$t('city[30]')}}</p>
      <a  class="point point-dot"></a>
      <div class="point point-10"></div>
      <div class="point point-70"></div>
    </div>
    <div class="point-area p32">
      <p class="point-name" style="position: absolute; top: 18px; left: 50px;">{{$t('city[31]')}}</p>
      <a  class="point point-dot"></a>
      <div class="point point-10"></div>
      <div class="point point-70"></div>
    </div>

  </div>
</template>

<script>
    export default {
        name: "mapa"
    }
</script>

<style lang="scss" scoped>
  .mainImg{
    width:1280px;
    margin: 0 auto;
    font-size: 13px;
    position: relative;
    color:#4DDAF0;
    img{
      width:100%;
      object-fit: cover;
    }
  .point-area{
    text-align: center;
    .point-name{
      font-size: 13px;
    }
  .point{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 6px;
    height: 6px;
    margin: auto;
    -webkit-border-radius: 50%;
    -webkit-background-clip: padding-box;
    -moz-border-radius: 50%;
    -moz-background-clip: padding;
    border-radius: 50%;
    background-clip: padding-box;
    background: transparent;
  }
  .point-dot{
    z-index: 1;
    background-color: #6AD7E9;
    border: 1px solid rgba(0, 205, 236, 0.37);
  }
  .point-10,.point-70，.point-40,.point-80{
    width:100%;
    height:100%;
  }
  .point-10::after{
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 50%;
    border: 2px solid #00cdec;
    opacity: 0;
    -webkit-animation: ripple 4500ms ease-out 225ms infinite;
    -moz-animation: ripple 4500ms ease-out 225ms infinite;
    -o-animation: ripple 4500ms ease-out 225ms infinite;
    animation: ripple 4500ms ease-out 225ms infinite;
  }
  .point-70::after{
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 50%;
    border: 2px solid #00cdec;
    opacity: 0;
    -webkit-animation: ripple 4500ms ease-out 1575ms infinite;
    -moz-animation: ripple 4500ms ease-out 1575ms infinite;
    -o-animation: ripple 4500ms ease-out 1575ms infinite;
    animation: ripple 4500ms ease-out 1575ms infinite;
  }
  .point-40::after{
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 50%;
    border: 2px solid #00cdec;
    opacity: 0;
    -webkit-animation: ripple 4500ms ease-out 225ms infinite;
    -moz-animation: ripple 4500ms ease-out 225ms infinite;
    -o-animation: ripple 4500ms ease-out 225ms infinite;
    animation: ripple 4500ms ease-out 225ms infinite;
  }
  .point-80::after{
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 50%;
    border: 2px solid #00cdec;
    opacity: 0;
    -webkit-animation: ripple 4500ms ease-out 1575ms infinite;
    -moz-animation: ripple 4500ms ease-out 1575ms infinite;
    -o-animation: ripple 4500ms ease-out 1575ms infinite;
    animation: ripple 4500ms ease-out 1575ms infinite;
  }
  @-webkit-keyframes ripple{
    0%{opacity:0;-webkit-transform:scale(0.1,0.1); }
    5%{ opacity:1; }
    100%{ opacity:0; -webkit-transform:scale(1)}
  }
  @-moz-keyframes ripple{
    0%{opacity:0;-moz-transform:scale(0.1,0.1); }
    5%{ opacity:1; }
    100%{ opacity:0; -moz-transform:scale(1)}
  }
  @keyframes ripple{
    0%{opacity:0;-webkit-transform:scale(0.1,0.1); }
    5%{ opacity:1; }
    100%{ opacity:0; -webkit-transform:scale(1)}
  }
  }
    .p1{
      top: 100px; left: 200px; position: absolute; width: 100px; height: 100px; visibility: visible; opacity: 1;
    }
    .p2{
      top: 40px; left: 180px; position: absolute; width: 100px; height: 100px; visibility: visible; opacity: 1;
    }
    .p3{
      top: 300px; left: 290px; position: absolute; width: 100px; height: 100px; visibility: visible; opacity: 1;
    }
    .p4{
      top: 420px; left: 320px; position: absolute; width: 100px; height: 100px; visibility: visible; opacity: 1;
    }
    .p5{
      top: 270px; left: 890px; position: absolute; width: 140px; height: 140px; visibility: visible; opacity: 1;
    }
    .p6{
      top: 200px; left: 920px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p13{
      top: 220px; left: 920px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p7{
      top: 175px; left: 984px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p8{
      top: 140px; left: 1010px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p9{
      top: 160px; left: 1040px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p10{
      top: 90px; left: 620px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p11{
      top: 230px; left: 240px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p12{
      top: 360px; left: 1000px; position: absolute; width: 150px; height: 150px; visibility: visible; opacity: 1;
    }
    .p14{
      top: 450px; left: 1135px; position: absolute; width: 150px; height: 150px; visibility: visible; opacity: 1;
    }
    .p15{
      top: 110px; left: 600px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p16{
      top: 120px; left: 580px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p17{
      top: 75px; left: 555px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p18{
      top: 78px; left: 548px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p19{
      top: 300px; left: 650px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p20{
      top: 400px; left: 650px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p21{
      top: 200px; left:720px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p22{
      top: 220px; left: 750px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p23{
      top: 220px; left: 840px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p24{
      top: 200px; left: 860px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p25{
      top: 280px; left: 890px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p26{
      top: 290px; left:970px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p27{
      top: 320px; left: 1050px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p28{
      top: 240px; left: 988px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p29{
      top: 60px; left: 800px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p30{
      top: 100px; left: 900px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p31{
      top: 100px; left: 800px; position: absolute; width: 80px; height: 80px; visibility: visible; opacity: 1;
    }
    .p32{
      top: 300px; left: 360px; position: absolute; width: 100px; height: 100px; visibility: visible; opacity: 1;
    }
    @media screen and (max-width:450px){
      width:100%;
      img{
        width:100%;
      }
      .point-area{
        .point-name{
          font-size: 10px;
        }
      }
      .p1{
        top:0px;
        left:50px;
      }
      .p2{
        top:-20px;
        left:20px;
      }
      .p3{
        left:75px;
        top:80px;
      }
      .p4{
        left:70px;
        top:110px;
      }
      .p5{
        top:40px;
        left:240px;
      }
      .p6{
        top:40px;
        left:280px;
      }
      .p7{
        top:20px;
        left:295px;
      }
      .p8{
        top:10px;
        left:310px;
      }
      .p9{
        top:5px;
        left:335px;
      }
      .p10{
        top:-5px;
        left:180px;
      }
      .p11{
        top:40px;
        left:40px;
      }
      .p12{
        top:70px;
        left:270px;
      }
      .p13{
        top:0px;
        left:170px;
      }
      .p14{
        top:15px;
        left:175px;
      }
    }
  }
</style>
